// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const checkboxClasses = {
  control: "qui-checkbox__control",
  errorText: "qui-checkbox__error-text",
  hiddenInput: "qui-checkbox__hidden-input",
  indicator: "qui-checkbox__indicator",
  label: "qui-checkbox__label",
  root: "qui-checkbox__root",
} as const
